import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../reducers';
import * as actions from '../actions/site';
import { Observable } from 'rxjs';
import { ListItem } from '../../core/models/list-item';
import { SearchCriteria } from '../models/search-criteria';
import * as searchActions from '../actions/search';

@Component({
  selector: 'app-map-search',
  template: `
  <p>
  To view all documents associated with a specific Superfund site, simply click on the map
  below to bring up a larger image. From within the larger map, you may click on a site name directly to view those site's documents,
  or click on a highlighted farm area to view a more detailed farm map. From within each farm map,
  you may click on a site name to view the records related to that site.  <b>Please ensure that your browser is set to 100% zoom level prior to using the Map Search for the best experience.</b>
</p>
<p>To see where the Beltsville Agricultural Research Center is located within the Baltimore-Washington Metropolitan Area, click
  <a href="http://maps.google.com/maps?f=q&source=s_q&hl=en&geocode=&q=10300+BALTIMORE+BLVD.+Beltsville,
    +MD+20705&sll=37.0625,-95.677068&sspn=41.95363,92.724609&ie=UTF8&hq=&hnear=10300+Baltimore+Ave,+Beltsville,
    +Prince+Georges,+Maryland+20705&ll=39.020251,-76.916656&spn=0.645494,1.448822&z=10"
    target="_blank">here</a>.
</p>
<p>
  <a (click)="showDialog()">
    <img src="../images/FullMap_Optimized.jpg"
      alt="Beltsville Agricultural Research Center Possible Environmental Areas of Concern"
      title="Beltsville Agricultural Research Center Possible Environmental Areas of Concern"
      height="367"
      width="570"
      class="photoborder" />
  </a>
</p>
<p-dialog header="Map Search" width="930" [(visible)]="displayDialog" (onHide)="resetMaps($event)">
  <div class="center-map" [hidden]="selectedFarm !== '' || selectedSiteAbbr !== ''">
    <irar-all-farms-map (selectFarm)="selectFarm($event)" [config]="config"></irar-all-farms-map>
  </div>
  <div class="center-map" [hidden]="selectedFarm !== 'SOUTH' || selectedSiteAbbr !== ''">
    <irar-south-farm-map (selectSite)="selectSite($event)" [config]="config"></irar-south-farm-map>
  </div>
  <div class="center-map" [hidden]="selectedFarm !== 'NORTH' || selectedSiteAbbr !== ''">
    <irar-north-farm-map (selectSite)="selectSite($event)" [config]="config"></irar-north-farm-map>
  </div>
  <div class="center-map" [hidden]="selectedFarm !== 'LINKAGE' || selectedSiteAbbr !== ''">
    <irar-linkage-farm-map (selectSite)="selectSite($event)" [config]="config"></irar-linkage-farm-map>
  </div>
  <div class="center-map" [hidden]="selectedFarm !== 'CENTRAL' || selectedSiteAbbr !== ''">
    <irar-central-farm-map (selectSite)="selectSite($event)" [config]="config"></irar-central-farm-map>
  </div>
  <div class="center-map" [hidden]="selectedFarm !== 'EAST' || selectedSiteAbbr !== ''">
    <irar-east-farm-map (selectSite)="selectSite($event)" [config]="config"></irar-east-farm-map>
  </div>
  <div [hidden]="selectedSiteAbbr === ''" style="max-height:300px;overflow:auto;">
    <irar-site-details
      [site]="selectedSite$ | async"
      (getDocuments)="searchDocuments($event)"
      [loading]="loading$ | async"></irar-site-details>
  </div>
  <div [hidden]="selectedFarm === ''" style="margin-top:10px;">
    <b><a (click)="goToFullMap()">Back to Full Map</a></b>
  </div>
</p-dialog>
  `
})
export class MapSearchContainerComponent {
  displayDialog = false;
  selectedFarm = '';
  selectedSiteAbbr = '';
  selectedSite$: Observable<ListItem>;
  loading$: Observable<boolean>;
  config = {
    fade: true,
    alwaysOn: false,
    neverOn: false,
    fill: true,
    fillColor: '#ff0066',
    fillOpacity: 0.2,
    stroke: true,
    strokeColor: '#ffffff',
    strokeOpacity: 1,
    strokeWidth: 1,
    shadow: true,
    shadowColor: '#33333',
    shadowOpacity: .8,
    shadowRadius: 10
  };

  constructor(private store: Store<fromRoot.State>) {
    this.selectedSite$ = this.store.select(fromRoot.getSelectedSite);
    this.loading$ = this.store.select(fromRoot.getSearchLoading);
  }

  showDialog() {
    this.displayDialog = true;
  }

  resetMaps(e: any) {
    this.selectedFarm = '';
    this.selectedSiteAbbr = '';
  }

  selectFarm(farm: string) {
    this.selectedFarm = farm;
  }

  selectSite(site: string) {
    this.selectedSiteAbbr = site;
    this.store.dispatch(new actions.SelectSiteAction(site));
  }

  searchDocuments(e: SearchCriteria) {
    this.store.dispatch(new searchActions.SearchDocumentsAction(e));
  }

  goToFullMap() {
    this.selectedFarm = '';
    this.selectedSiteAbbr = '';
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/containers/map-search.ts